import Image from "@/services/Image"

export default class CatalogImage {
  static handle(
    host,
    name,
    w = null,
    h = null,
  ) {
    if (host && name) {
      return Image.handle(host, name, w, h)
    } else {
      return CatalogImage.default()
    }
  }

  static default() {
    return "/assets/static/catalog/no_image.jpg"
  }
}
